var premiumVariants = {
  1: '40742340198472',  // < $100
  2: '40742340231240',  // < $200
  3: '40742340264008',  // < $300
  4: '40742340296776',  // < $400
  5: '40742340329544'   // >= $400
};
var premiumIds = Object.values(premiumVariants);

document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("ella:cartChange", function (e) {
    return;
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        autoAddPremiumDeliveryServiceProducts(cart);
      });
  });
  window.addEventListener("ella:removeCart", function(e) {
    return;
    var removedItems = e.detail.items_removed;
    var premiumRemoved = false;

    for (var id of premiumIds) {
      if (removedItems.some((x) => id === x.variant_id.toString())) {
        premiumRemoved = true;
      }
    }

    if (!premiumRemoved) {
      fetch("/cart.js")
        .then(res => res.json())
        .then(cart => {
          autoAddPremiumDeliveryServiceProducts(cart)
        });
    }
  })
});

function autoAddPremiumDeliveryServiceProducts(cart) {

  var totalPrice = cart.total_price / 100;

  var correctPremium = '';

  if (totalPrice < 100) {
    correctPremium = premiumVariants[1];
  } else if (totalPrice < 200) {
    correctPremium = premiumVariants[2];
  } else if (totalPrice < 300) {
    correctPremium = premiumVariants[3];
  } else if (totalPrice < 400) {
    correctPremium = premiumVariants[4];
  } else {
    correctPremium = premiumVariants[5];
  }

  var premiumInCart = cart.items.find(item => premiumIds.includes(item.variant_id.toString()));

  if (cart.items.length === 1 && premiumInCart) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        line: 1,
        quantity: 0
      })
    })
      .then(res => res.json())
      .then(() => {
        if (window.globalElla && typeof globalElla.updateDropdownCart === "function") {
          globalElla.updateDropdownCart();
        }
      })
      .catch(err => console.error("❌ Failed to remove single premium:", err));
    return;
  }

  if (cart.items.length <= 0) {
    return;
  }

  if (premiumInCart && premiumInCart.variant_id.toString() === correctPremium) {
    if (premiumInCart.quantity !== 1) {
      var lineToUpdate = cart.items.findIndex(item => item.variant_id === premiumInCart.variant_id) + 1;

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ line: lineToUpdate, quantity: 1 })
      })
        .then(res => res.json())
        .then(() => {
          if (window.globalElla && typeof globalElla.updateDropdownCart === "function") {
            globalElla.updateDropdownCart();
          }
        })
        .catch(err => console.error("❌ Failed to fix premium quantity:", err));
    } else {
      // console.log("Correct premium variant already in cart with quantity 1.");
    }
    return;
  }

  if (premiumInCart && premiumInCart.variant_id.toString() !== correctPremium) {
    var lineToRemove = cart.items.findIndex(
      item => item.variant_id === premiumInCart.variant_id
    ) + 1; // Shopify lines are 1-based

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        line: lineToRemove,
        quantity: 0
      })
    })
      .then(res => res.json())
      .then(() => {
        addPremiumVariant(correctPremium);
      })
      .catch(err => console.error("Failed to remove old premium:", err));

    return;
  }

  if (!premiumInCart) {
    addPremiumVariant(correctPremium);
  }
}

function addPremiumVariant(variantId) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
    .then(res => res.json())
    .then(item => {
      if (window.globalElla && typeof globalElla.updateDropdownCart === "function") {
        globalElla.updateDropdownCart();
      }
    })
    .catch(err => console.error("Failed to add premium delivery service:", err));
}

function recommendationSwipe() {
    console.log('recommend swipe test');
  const imageContainers = document.querySelectorAll('.product-image.image-swap');

  imageContainers.forEach(container => {
    let touchStartX = 0;
    let touchEndX = 0;

    console.log('swipe logic');

    // 1. Swipe Logic
    container.addEventListener('touchstart', (e) => {
      console.log('touch start')
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    container.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      
      if (window.innerWidth <= 768) {
        console.log('touched');
        const swipeDistance = 50; // threshold in pixels
        const diff = touchStartX - touchEndX;

        // If swiped left (diff > 50) or right (diff < -50)
        if (Math.abs(diff) > swipeDistance) {
          container.classList.toggle('show-mobile');
        }
      }
    }, { passive: true });
  });

  const arrows = document.querySelectorAll('.custom-image-arrows-container custom-image-arrow');

  arrows.forEach(arrow => {
    arrow.addEventListener('click', (event) => {
      if (window.innerWidth <= 768) {
        event.stopPropagation();
        event.preventDefault();

        const targetElement = arrow.closest('.product-image.image-swap'); 
        if (targetElement) {
          targetElement.classList.toggle('show-mobile');
        }
      }
    });
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 768) {
      const activeElements = document.querySelectorAll('.product-image.image-swap.show-mobile');
      
      activeElements.forEach(el => {
        el.classList.remove('show-mobile');
      });
    }
  });

}

// Accessibility Fix: Add aria label to dynamic klaviyo button
const forceFavoritesLabel = () => {
  const favButton = document.querySelector('.kl-hub-favorites-widget');
  
  if (favButton) {
    if (favButton.getAttribute('aria-label') !== 'Add to favorites') {
      favButton.setAttribute('aria-label', 'Add to favorites');
    }
  }
};

setInterval(forceFavoritesLabel, 500);

document.addEventListener('DOMContentLoaded', forceFavoritesLabel);

// Accessibility Fix: Add aria labels to the Contribe app buttons
const forceShadowContribeLabels = () => {
  const shadowHost = document.querySelector('contribe-plugin');
  
  if (shadowHost && shadowHost.shadowRoot) {
    const projectButtons = shadowHost.shadowRoot.querySelectorAll('.contribe-selector-project-button');
    
    projectButtons.forEach((button, index) => {
      const targetLabel = `Select donation project ${index + 1}`;
      
      if (button.getAttribute('aria-label') !== targetLabel) {
        button.setAttribute('aria-label', targetLabel);
      }
    });
  }
};

setInterval(forceShadowContribeLabels, 400);

document.addEventListener('DOMContentLoaded', forceShadowContribeLabels);

// Accessibility Fix: Add aria and role attributes to timesact back-in-stock empty heading
const forceTimesactAttributes = () => {
  const rogueHeading = document.querySelector('.timesact_bis_heading');

  if (rogueHeading && rogueHeading.tagName === 'H3') {
    const genericDiv = document.createElement('div');
    
    genericDiv.className = rogueHeading.className;
    genericDiv.innerHTML = rogueHeading.innerHTML;
    
    genericDiv.setAttribute('role', 'presentation');
    genericDiv.setAttribute('aria-hidden', 'true');
    
    rogueHeading.parentNode.replaceChild(genericDiv, rogueHeading);
  }
}

setInterval(forceTimesactAttributes, 400);

document.addEventListener('DOMContentLoaded', forceTimesactAttributes);

// Accessibility Fix (global slider roles): strips/replaces invalid ARIA roles
// added by carousel libraries (Splide: role="group" on <li> slides; Slick:
// role="option" on slides, role="listbox" on tracks). One MutationObserver
// covers every slider site-wide, incl. app-rendered ones (Kaching cart).
// Rules below only match the broken state, so fixes are idempotent and the
// observer settles instead of looping. Add a rule here for future sliders.
(function () {
  if (typeof jQuery !== 'undefined') {
    var labelForTrack = function (track) {
      var $el = jQuery(track).closest('.slick-initialized').first();
      if (!$el.length) $el = jQuery(track).closest('section').first();
      var label = $el.closest('.grid-row-collection').find('.widget-title h2, .widget-title h3').first().text().trim();
      if (!label) label = $el.find('.widget-title h2, .widget-title h3').first().text().trim();
      if (!label) label = $el.find('h1, h2, h3').first().text().trim();
      return label || 'Product carousel';
    };
  }

  var SLIDE_ROLE_FIXERS = [
    {
      sel: 'li[role]',
      fix: function (el) { el.removeAttribute('role'); }
    },
    {
      sel: '.slick-slide[role], .slick-slide[aria-describedby]',
      fix: function (el) {
        el.removeAttribute('role');
        el.removeAttribute('aria-describedby');
      }
    },
    {
      sel: '.slick-track[role="listbox"]',
      fix: function (el) {
        el.setAttribute('role', 'group');
        el.setAttribute('aria-label',
          typeof jQuery !== 'undefined' ? labelForTrack(el) : 'Product carousel');
      }
    }
  ];

  var applyFixers = function (root) {
    if (!root || root.nodeType !== 1) return;
    try {
      SLIDE_ROLE_FIXERS.forEach(function (rule) {
        if (root.matches && root.matches(rule.sel)) rule.fix(root);
        if (root.querySelectorAll) {
          root.querySelectorAll(rule.sel).forEach(rule.fix);
        }
      });
    } catch (err) {
      // never break theme callbacks
    }
  };

  applyFixers(document.body);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      applyFixers(mutation.target);
      mutation.addedNodes.forEach(applyFixers);
    });
  }).observe(document.body, {
    attributes: true,
    attributeFilter: ['role', 'aria-describedby'],
    childList: true,
    subtree: true
  });
})();

// Accessibility Fix: hide decorative app-injected canvases (kaching cart
// confetti) from assistive tech so they no longer trip the axe "region"
// (landmark) rule. The markup is injected by the app directly into <body>,
// outside any landmark, so it must be hidden instead of wrapped.
(function () {
  var hideDecorativeCanvases = function (root) {
    (root || document).querySelectorAll('canvas[id*="kaching"]:not([aria-hidden])').forEach(function (canvas) {
      canvas.setAttribute('aria-hidden', 'true');
      canvas.setAttribute('role', 'presentation');
    });
  };

  hideDecorativeCanvases(document);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'CANVAS' && node.id.indexOf('kaching') !== -1) {
          node.setAttribute('aria-hidden', 'true');
          node.setAttribute('role', 'presentation');
        } else if (node.querySelectorAll) {
          hideDecorativeCanvases(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

// Slick marks off-screen slides aria-hidden but leaves their links tabbable;
// neutralize focusables in hidden/cloned slides and restore them when a
// slide comes back into view. Must use jQuery delegation: slick fires its
// init/afterChange/reInit/breakpoint events via jQuery trigger(), which
// does not reach native addEventListener.
(function ($) {
  if (!$) return;
  var focusableSel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]';
  $(document).on('init afterChange reInit breakpoint', '.products-grid, .slick-initialized', function () {
    $(this).find('.slick-slide').each(function () {
      var hidden = $(this).attr('aria-hidden') === 'true' || $(this).hasClass('slick-cloned');
      var $focusable = $(this).find(focusableSel);
      if (hidden) {
        $focusable.attr('tabindex', '-1');
      } else {
        $focusable.filter('[tabindex="-1"]').removeAttr('tabindex');
      }
    });
  });
})(window.jQuery);
